module.exports = __webpack_public_path__ + "assets/img/CTA-cartoucherie-7etapes1.04ff91ed.jpg";